import Joi from 'joi';
import schemas from 'components/forms/fields/definedSchemas';

const fields = {
    supporting_document_type: {
        ...schemas.radioRequired,
        section: 'DocInfo',
        label: 'Select which type of document you uploaded',
        options: {
            'TWIC Card': 'TWIC Card',
            'TWIC Receipt': 'TWIC Receipt',
            'Picture of my Merchant Mariner Credential':
                'Picture of my Merchant Mariner Credential',
            'DOT/ USCG Periodic Drug Test Document':
                'DOT/ USCG Periodic Drug Test Document',
            'USCG Pay.gov Fees Receipt': 'USCG Pay.gov Fees Receipt',
            'Merchant Mariner Oath': 'Merchant Mariner Oath',
            'Proof of Identification': 'Proof of Identification',
            'Proof of Ownership for CG-719S': 'Proof of Ownership for CG-719S',
            'Active Duty Qualification Letter':
                'Active Duty Qualification Letter',
            'Other Mariner Document': 'Other Mariner Document',
        },
    },
    twic_card_receipt_type: {
        ...schemas.radioRequired,
        section: 'DocInfo',
        label: 'What type of TWIC Receipt do you have? ',
        options: {
            'Original TWIC Receipt': 'Original TWIC Receipt',
            'Renewal TWIC Receipt': 'Renewal TWIC Receipt',
        },
        validation: Joi.string().when(Joi.ref('supporting_document_type'), {
            is: 'TWIC Receipt',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    twic_card_receipt_date: {
        ...schemas.dateRequiredMaxToday,
        section: 'DocInfo',
        label: 'Date on TWIC Receipt',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'TWIC Receipt',
            then: schemas.dateRequiredMaxToday.validation,
            otherwise: Joi.string().allow(''),
        }),
    },
    twic_card_date_issued: {
        label: 'Date TWIC issued',
    },
    twic_card_date_expired: {
        ...schemas.dateRequired,
        section: 'DocInfo',
        label: 'Date TWIC expires',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'TWIC Card',
            then: schemas.dateRequired.validation,
            otherwise: Joi.string().allow(''),
        }),
    },
    drug_test_type: {
        ...schemas.radioRequired,
        section: 'DocInfo',
        label: 'What type of  Drug Test documentation  is this?',
        options: {
            'Drug Test Letter ': 'Drug Test Letter ',
            'Drug Test Form CG 719P': 'USCG 5-Panel Drug Test Form CG 719P',
        },
        validation: Joi.string().when(Joi.ref('supporting_document_type'), {
            is: 'DOT/ USCG Periodic Drug Test Document',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    drug_test_date_issued: {
        ...schemas.dateRequiredMaxToday,
        section: 'DocInfo',
        label: 'What date was this Drug Test documentation issued?',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'DOT/ USCG Periodic Drug Test Document',
            then: schemas.dateRequiredMaxToday.validation,
            otherwise: Joi.string().allow(''),
        }),
    },
    mmc_image_document_number: {
        ...schemas.textOptional,
        section: 'DocInfo',
        label: 'What is the document number on this Merchant Mariner Credential?',
        validation: Joi.string().when(Joi.ref('supporting_document_type'), {
            is: 'Picture of my Merchant Mariner Credential',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    mmc_all_pages: {
        ...schemas.boolOptional,
        section: 'DocInfo',
        label: 'Did you upload all pages from your MMC that have information on them?',
        validation: Joi.string().when(Joi.ref('supporting_document_type'), {
            is: 'Picture of my Merchant Mariner Credential',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    mariner_fees_receipt: {
        ...schemas.dollarAmountRequired,
        section: 'DocInfo',
        label: 'How much is the fee is on this Pay.Gov receipt?',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'USCG Pay.gov Fees Receipt',
            then: schemas.dollarAmountRequired.validation,
            otherwise: Joi.string().allow('', null),
        }),
    },
    mariner_fees_receipt_used_previous: {
        ...schemas.boolOptional,
        section: 'DocInfo',
        label: 'Has this Pay.Gov receipt been used in a previous application?',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'USCG Pay.gov Fees Receipt',
            then: Joi.boolean().required(),
            otherwise: Joi.boolean().allow(''),
        }),
    },
    oath_date: {
        ...schemas.dateRequiredMaxToday,
        section: 'DocInfo',
        label: 'What date was the Merchant Mariner Oath taken?',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'Merchant Mariner Oath',
            then: schemas.dateRequiredMaxToday.validation,
            otherwise: Joi.string().allow(''),
        }),
    },
    oath_used_previous: {
        ...schemas.boolOptional,
        section: 'DocInfo',
        label: 'Has the Oath been used in a previous application?',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'Merchant Mariner Oath',
            then: Joi.boolean().required(),
            otherwise: Joi.boolean().allow(''),
        }),
    },
    proof_of_identification_type: {
        ...schemas.radioRequired,
        section: 'DocInfo',
        label: 'Is this your Passport or Birth Certificate?',
        options: {
            Passport: 'Passport',
            'Birth Certificate': 'Birth Certificate',
        },
        validation: Joi.string().when(Joi.ref('supporting_document_type'), {
            is: 'Proof of Identification',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    passport_date_issued: {
        ...schemas.dateRequiredMaxToday,
        section: 'DocInfo',
        label: 'What day was the Passport Issued?',
        validation: Joi.when(Joi.ref('proof_of_identification_type'), {
            is: 'Passport',
            then: schemas.dateRequiredMaxToday.validation,
            otherwise: Joi.string().allow(''),
        }),
    },
    passport_date_expired: {
        ...schemas.dateRequired,
        section: 'DocInfo',
        label: 'What day does the Passport Expire?',
        validation: Joi.when(Joi.ref('proof_of_identification_type'), {
            is: 'Passport',
            then: schemas.dateRequired.validation
                .min(Joi.ref('passport_date_issued'))
                .messages({
                    'date.min': "Passport can't expire before it was issued.",
                }),
            otherwise: Joi.string().allow(''),
        }),
    },
    proof_of_ownership_type: {
        ...schemas.radioRequired,
        section: 'DocInfo',
        label: 'What type of Proof of Ownership are you adding?',
        options: {
            Title: 'Title',
            'Registration (state registered vessels)':
                'Registration (state registered vessels)',
            'Certificate of Documentation (U.S. Coast Guard registered vessels)':
                'Certificate of Documentation (U.S. Coast Guard registered vessels)',
            'Bill of sale': 'Bill of sale',
        },
        validation: Joi.string().when(Joi.ref('supporting_document_type'), {
            is: 'Proof of Ownership for CG-719S',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    proof_of_ownership_date_issued: {
        ...schemas.dateRequiredMaxToday,
        section: 'DocInfo',
        label: 'What date was the Proof of Ownership issued?',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'Proof of Ownership for CG-719S',
            then: schemas.dateRequiredMaxToday.validation,
            otherwise: Joi.string().allow(''),
        }),
    },
    qual_letter_service: {
        ...schemas.radioRequired,
        section: 'DocInfo',
        label: 'Select which type of document you uploaded',
        options: {
            USCG: 'USCG',
            NOAA: 'NOAA',
            ARMY: 'ARMY',
            NAVY: 'NAVY',
            MARINES: 'MARINES',
            'AIR FORCE': 'AIR FORCE',
            USPHS: 'USPHS',
            'SPACE FORCE': 'SPACE FORCE',
        },
        validation: Joi.string().when(Joi.ref('supporting_document_type'), {
            is: 'Active Duty Qualification Letter',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    qual_letter_ood_or_eow: {
        ...schemas.radioRequired,
        section: 'DocInfo',
        label: 'Is this an OOD or EOW Qualification Letter?',
        options: {OOD: 'OOD', EOW: 'EOW'},
        validation: Joi.string().when(Joi.ref('qual_letter_service'), {
            is: val =>
                val ===
                ('USCG' ||
                    'NOAA' ||
                    'NAVY' ||
                    'MARINES' ||
                    'USPHS' ||
                    'AIR FORCE' ||
                    'SPACE FORCE'),
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    qual_letter_army_deck_engine: {
        ...schemas.radioRequired,
        section: 'DocInfo',
        label: 'What Department is this Underway Watch Officer Qualifiaction Letter for?',
        options: {Deck: 'Deck', Engine: 'Engine'},
        validation: Joi.string().when(Joi.ref('qual_letter_service'), {
            is: 'ARMY',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    qual_letter_date_issued: {
        ...schemas.dateRequiredMaxToday,
        section: 'DocInfo',
        label: 'What day is this Qualification Letter Issued? ',
        initialValue: null,
        validation: Joi.when(Joi.ref('qual_letter_service'), {
            is: val =>
                val ===
                ('USCG' ||
                    'NOAA' ||
                    'NAVY' ||
                    'MARINES' ||
                    'USPHS' ||
                    'AIR FORCE' ||
                    'SPACE FORCE'),
            then: schemas.dateRequiredMaxToday.validation,
            otherwise: Joi.string().allow(''),
        }),
    },
    qual_letter_vessel: {
        ...schemas.textOptional,
        section: 'DocInfo',
        label: 'What Vessel this Qualification Letter Issued for?',
    },
    extra_maritime_document_name: {
        ...schemas.textRequired,
        section: 'DocInfo',
        label: 'What is the Name of this Maritime Document?',
        validation: Joi.when(Joi.ref('supporting_document_type'), {
            is: 'Other Mariner Document',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    extra_maritime_document_date_issued: {
        ...schemas.dateOptionalMaxToday,
        section: 'DocInfo',
        label: 'When was the document issued?',
    },
    extra_maritime_document_date_expired: {
        ...schemas.dateOptional,
        section: 'DocInfo',
        label: 'When does the document expire?',
        initialValue: null,
        validation: Joi.string().allow('', null),
    },
    extra_maritime_document_additional_information: {
        ...schemas.textOptional,
        section: 'DocInfo',
        label: 'Additional Information about this document',
        validation: Joi.string().allow('', null),
    },
};

export default fields;
